"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addViewModels = exports.getMusicDetailsViewModel = exports.TMusicDetailsViewModel = exports.getAddNewSongViewModel = exports.TAddNewSongViewModel = exports.getPlayerViewModel = exports.TPlayerViewModel = exports.getNavigationBarViewModel = exports.TNavigationBarViewModel = exports.getAboutViewModel = exports.TAboutViewModel = exports.getMusicViewModel = exports.TMusicViewModel = exports.getHomeViewModel = exports.THomeViewModel = exports.getMainViewModel = exports.TMainViewModel = void 0;
const tsyringe_1 = require("tsyringe");
const AboutViewModel_1 = require("./views/viewModels/AboutViewModel");
const AddNewSongViewModel_1 = require("./views/viewModels/AddNewSongViewModel");
const HomeViewModel_1 = require("./views/viewModels/HomeViewModel");
const MainViewModel_1 = require("./views/viewModels/MainViewModel");
const MusicDetailsViewModel_1 = require("./views/viewModels/MusicDetailsViewModel");
const MusicViewModel_1 = require("./views/viewModels/MusicViewModel");
const NavigationBarViewModel_1 = require("./views/viewModels/NavigationBarViewModel");
const PlayerViewModel_1 = require("./views/viewModels/PlayerViewModel");
exports.TMainViewModel = Symbol("MainViewModel");
function getMainViewModel() {
    let value = tsyringe_1.container.resolve(exports.TMainViewModel);
    return value;
}
exports.getMainViewModel = getMainViewModel;
;
exports.THomeViewModel = Symbol("HomeViewModel");
function getHomeViewModel() {
    let value = tsyringe_1.container.resolve(exports.THomeViewModel);
    return value;
}
exports.getHomeViewModel = getHomeViewModel;
;
exports.TMusicViewModel = Symbol("MusicViewModel");
function getMusicViewModel() {
    let value = tsyringe_1.container.resolve(exports.TMusicViewModel);
    return value;
}
exports.getMusicViewModel = getMusicViewModel;
;
exports.TAboutViewModel = Symbol("AboutViewModel");
function getAboutViewModel() {
    let value = tsyringe_1.container.resolve(exports.TAboutViewModel);
    return value;
}
exports.getAboutViewModel = getAboutViewModel;
;
exports.TNavigationBarViewModel = Symbol("NavigationBarViewModel");
function getNavigationBarViewModel() {
    let value = tsyringe_1.container.resolve(exports.TNavigationBarViewModel);
    return value;
}
exports.getNavigationBarViewModel = getNavigationBarViewModel;
;
exports.TPlayerViewModel = Symbol("TPlayerViewModel");
function getPlayerViewModel() {
    let value = tsyringe_1.container.resolve(exports.TPlayerViewModel);
    return value;
}
exports.getPlayerViewModel = getPlayerViewModel;
;
exports.TAddNewSongViewModel = Symbol("AddNewSongViewModel");
function getAddNewSongViewModel() {
    let value = tsyringe_1.container.resolve(exports.TAddNewSongViewModel);
    return value;
}
exports.getAddNewSongViewModel = getAddNewSongViewModel;
;
exports.TMusicDetailsViewModel = Symbol("MusicDetailsViewModel");
function getMusicDetailsViewModel() {
    let value = tsyringe_1.container.resolve(exports.TMusicDetailsViewModel);
    return value;
}
exports.getMusicDetailsViewModel = getMusicDetailsViewModel;
;
function addViewModels() {
    tsyringe_1.container.registerType(exports.TMainViewModel, MainViewModel_1.MainViewModel);
    tsyringe_1.container.registerType(exports.THomeViewModel, HomeViewModel_1.HomeViewModel);
    tsyringe_1.container.registerType(exports.TMusicViewModel, MusicViewModel_1.MusicViewModel);
    tsyringe_1.container.registerType(exports.TAboutViewModel, AboutViewModel_1.AboutViewModel);
    tsyringe_1.container.registerType(exports.TNavigationBarViewModel, NavigationBarViewModel_1.NavigationBarViewModel);
    tsyringe_1.container.registerType(exports.TPlayerViewModel, PlayerViewModel_1.PlayerViewModel);
    tsyringe_1.container.registerType(exports.TAddNewSongViewModel, AddNewSongViewModel_1.AddNewSongViewModel);
    tsyringe_1.container.registerType(exports.TMusicDetailsViewModel, MusicDetailsViewModel_1.MusicDetailsViewModel);
}
exports.addViewModels = addViewModels;
//# sourceMappingURL=viewModelCollection.js.map